export default {"src":"/_next/static/media/FB2.8f0bc031.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};